import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessDeniedComponent } from './commonComponents/access-denied/access-denied.component';
import { LogoutComponent } from './commonComponents/logout/logout.component';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { HomeFooterComponent } from './home-footer/home-footer.component';
import { HowitworksComponent } from './howitworks/howitworks.component';
import { PaymentprocessComponent } from './paymentprocess/paymentprocess.component';
import { SharedProfileComponent } from './doctor-shared-profile/shared-profile.component';
import { DoctorreportpdfComponent } from './doctorreportpdf/doctorreportpdf.component';
import { ShareMessageDoctorsComponent } from 'src/app/components/shared/share-message-doctors/share-message-doctors.component';
import { PrescriptionDetailsComponent } from 'src/app/components/shared/prescription-details/prescription-details.component';
import { NoteDoctorsComponent } from './note-doctors/note-doctors.component';
import { PatientAppointmentHistoryComponent } from './patient-appointment-history/patient-appointment-history.component';
import { DoctorsListComponent } from './doctors-list/doctors-list.component';
import { HomeSpecialComponent } from './home-special/home-special.component';
import { FeedbackSectionComponent } from '../shared/feedback-section/feedback-section.component';
import { MobileAppBadgesComponent } from './mobile-app-badges/mobile-app-badges.component';
import { MedicalProffessionalRegistrationComponent } from './medical-proffessional-registration/medical-proffessional-registration.component';
import { OtherMedicalProfeSharedProfileComponent } from './other-medical-profe-shared-profile/other-medical-profe-shared-profile.component';
import { FieldValidatorDirective } from 'src/app/directives/FieldValidator';
import { HomeTopBarComponent } from './home-top-bar/home-top-bar.component';
import { NotFoundPageComponent } from './commonComponents/not-found-page/not-found-page.component';
import { InvalidLinkComponent } from './commonComponents/invalid-link/invalid-link.component';
import { CommonUserFormComponent } from './user/common-user-form/common-user-form.component';
import { TableDataComponent } from './table-data/table-data.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ThankYouComponent } from './commonComponents/thank-you/thank-you.component';
import { InvoiceModule } from './invoice/invoice.module';
import { PatientViewModule } from './patient-view/patient-view.module';
import { JoinPipe } from 'src/app/pipes/join.pipe';
import { SessionExpiredComponent } from './commonComponents/session-expired/session-expired.component';
import { PaymentComponent } from './payment/payment.component';
import { UtilitiesModule } from './utilities/utilities.module';
import { UseridInputComponent } from './userid-input/userid-input.component';
import { CustomDateFormatPipe } from '../../pipes/custom.dateformat.pipe';
import { TimeSlotsComponent } from './time-slots/time-slots.component';
import { AdLandingpageTopBarComponent } from './ad-landingpage-top-bar/ad-landingpage-top-bar.component';
import { ConsultationFlowPaymentComponent } from './consultation-flow-payment/consultation-flow-payment.component';
const COMPONENTS = [
    LogoutComponent,
    NotFoundPageComponent,
    InvalidLinkComponent,
    AccessDeniedComponent,
    HomeTopBarComponent,
    HomeFooterComponent,
    HowitworksComponent,
    PaymentprocessComponent,
    SharedProfileComponent,
    ShareMessageDoctorsComponent,
    NoteDoctorsComponent,
    PatientAppointmentHistoryComponent,
    DoctorsListComponent,
    HomeSpecialComponent,
    FeedbackSectionComponent,
    MobileAppBadgesComponent,
    MedicalProffessionalRegistrationComponent,
    OtherMedicalProfeSharedProfileComponent,
    FieldValidatorDirective,
    CommonUserFormComponent,
    TableDataComponent,
    ConfirmDialogComponent,
    ThankYouComponent,
    JoinPipe,
    SessionExpiredComponent,
    PaymentComponent,
    UseridInputComponent,
    CustomDateFormatPipe,
    TimeSlotsComponent,
    AdLandingpageTopBarComponent,
    ConsultationFlowPaymentComponent
];
@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        PrimengModule,
        InvoiceModule,
        PatientViewModule,
        UtilitiesModule
    ],
    exports: [...COMPONENTS, PatientViewModule]
})
export class SharedModule { }
